export const GET_ADMIN_SEARCH_LIST_REQUEST = 'GET_ADMIN_SEARCH_LIST_REQUEST';
export const GET_ADMIN_SEARCH_LIST_SUCCESS = 'GET_ADMIN_SEARCH_LIST_SUCCESS';
export const GET_ADMIN_SEARCH_LIST_FAILURE = 'GET_ADMIN_SEARCH_LIST_FAILURE';

export const ADD_ADMIN_LOCATION_REQUEST = 'ADD_ADMIN_LOCATION_REQUEST';
export const ADD_ADMIN_LOCATION_SUCCESS = 'ADD_ADMIN_LOCATION_SUCCESS';
export const ADD_ADMIN_LOCATION_FAILURE = 'ADD_ADMIN_LOCATION_FAILURE';

export const GET_INVITED_ADMIN_REQUEST = 'GET_INVITED_ADMIN_REQUEST';
export const GET_INVITED_ADMIN_SUCCESS = 'GET_INVITED_ADMIN_SUCCESS';
export const GET_INVITED_ADMIN_FAILURE = 'GET_INVITED_ADMIN_FAILURE';

export const REMOVE_INVITED_ADMIN_REQUEST = 'REMOVE_INVITED_ADMIN_REQUEST';
export const REMOVE_INVITED_ADMIN_SUCCESS = 'REMOVE_INVITED_ADMIN_SUCCESS';
export const REMOVE_INVITED_ADMIN_FAILURE = 'REMOVE_INVITED_ADMIN_FAILURE';

export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
